import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import USFlagIcon from '../Icons/USFlagIcon';

const PhoneNumberMaskInput = forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='+1(000) 000-0000'
      inputRef={ref}
      onAccept={value => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

PhoneNumberMaskInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const PhoneNumberInput = forwardRef((props, ref) => {
  return (
    <TextField
      {...props}
      ref={ref}
      autoComplete='tel'
      sx={{
        '& .MuiOutlinedInput-input': {
          padding: '12px 16px 12px 10px',
        },
      }}
      slotProps={{
        input: {
          inputComponent: PhoneNumberMaskInput,
          startAdornment: (
            <div className='py-[6px] pr-[10px] border-r-[1px]'>
              <USFlagIcon />
            </div>
          ),
          className: 'tel-input',
        },
      }}
    />
  );
});

PhoneNumberInput.defaultProps = {
  id: 'phone-number',
  placeholder: '+1 (XXX) XXX - XXX',
};

export default PhoneNumberInput;
